<div *ngIf="modo==''">
    <!-- <p-table #tt [value]="arquivos" [paginator]="true" [rows]="linhas"   [style]="{'margin-top':'3px'}" 
[globalFilterFields]="['titulo','dia','descricao','tipo']" sortMode="multiple"
(sortFunction)="customSort($event)" [customSort]="true">
<ng-template pTemplate="caption">
    <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
    <input type="text" pInputText size="50" placeholder="Busca" (input)="tt.filterGlobal($event.target.value, 'contains')"
      style="width:auto">
  </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="'titulo'" >Item</th>
            <th *ngIf="!mini" [pSortableColumn]="'dia'"  style="width: 125px">Data</th>
            <th *ngIf="mini" [pSortableColumn]="'dia'"  style="width: 75px">Data</th>
            <th *ngIf="!mini" [pSortableColumn]="'tipo'" style="width: 100px">Download</th>
            <th *ngIf="mini" [pSortableColumn]="'tipo'" style="width: 70px">Baixar</th>
            
            <th style='width:110px' *ngIf="edicao">Ações</th>
            
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-car>
        <tr>
            <td >
              <div>
                  <span *ngIf="!mini" style="font-family: 'Roboto';font-weight: bolder; font-size: 20px; color:orangered;text-shadow: 2px 1px 1px #6d4a4a;">{{car.titulo}} 
                  
                  </span>
            <div *ngIf="mini" style="font-family: 'Roboto';display: inline-block;;font-weight: bolder; font-size: 12px; color:orangered;text-shadow: 0px 1px 1px #6d4a4a;">{{car.titulo}}</div>
                  <span *ngIf="!mini"style="font-family: 'chique';font-size: 17px;
                  line-height: 0.9;
                  letter-spacing: 0.003em;" innerHTML="{{car.descricao}}{{mlinks?'Arquivo: '+car.link:''}}"></span>
                  <div *ngIf="mini" style="font-family: 'chique';display: inline-block;margin-left:4px; font-size: 11px;" innerHTML="{{car.descricao | htmlRemovedor}}"></div>
                  

              </div>
            
            
            
            
            </td>

            <td>
                <span *ngIf="!mini" style="font-family: 'Roboto';font-size: 20px">{{car.dia | dataMomento}}</span>
                <span *ngIf="mini" style="font-family: 'Roboto';font-size: 10px">{{car.dia | dataMomento}}</span>

            </td>
            <td style='text-align:center'>
                <a style="cursor:pointer" *ngIf="mini" (click)="baixar(car.link,car.titulo,car.tipo)" > <img src="assets/{{car.imagemArquivo}}" width="23px" height="23px" style="filter: drop-shadow(7px 7px 3px #9d8f8f);"></a>
                <a style="cursor:pointer" *ngIf="!mini" (click)="baixar(car.link,car.titulo,car.tipo)" > <img src="assets/{{car.imagemArquivo}}" width="50px" height="50px" style="filter: drop-shadow(7px 7px 3px #9d8f8f);"></a>
            </td>
            
           
            
            <td *ngIf="edicao" style='text-align:center;width:110px'>
                
                <span >
                <button pButton type="button" icon="pi pi-pencil" iconPos="left"  (click)="editarEquipamento(car)" pTooltip="Editar"></button><span style="margin-left: 6px"></span>
            </span> 
            <span >
                <button pButton type="button" icon="pi pi-trash" class="ui-button-danger" iconPos="left"  (click)="confirmarExclusao(car)" pTooltip="Excluir"></button>
            </span>
            
            </td>
            
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-car>
            <tr>
                <td *ngIf="edicao"  colspan="4">
                    Não há arquivos nesta seção (ou ainda não foram carregados).
                </td>

                <td *ngIf="!edicao"  colspan="3">
                    Não há arquivos nesta seção (ou ainda não foram carregados).
                </td>
            </tr>
        </ng-template>
</p-table> -->


<div *ngIf="arquivos ">
    <div style="text-align: center;">
        <div *ngIf="busca || (arquivos.length>1 || arquivos.length===0 )" class="casca" style="text-align: right;font-size: 1.2em;">
            <div class="infoBar">
               🗃️ {{arquivos?.length}} listado(s).
            </div>
            🔎<input  [(ngModel)]="busca" (ngModelChange)="mudouFiltro()" type="text" [style]="{'width':'130px','height':'20px'}"  pInputText>
        </div>

        
        
    </div>
    
    <div *ngFor="let arq of arquivos" style="text-align: center;" class="jota">
        
        <div class="casca">
            <div class="titleBox">
                {{arq.titulo}}
            </div>
            <div class="icone">
                <a style="cursor:pointer"  (click)="baixar(arq.link,arq.titulo,arq.tipo)" > <img src="assets/{{arq.imagemArquivo}}" width="25px" height="25px" ></a>
                <div style="font-size: 0.75em;font-weight: bolder;font-family: 'Roboto';font-style: normal;line-height: 1.4;">
                    {{arq.dia | dataMomento}}
                    <div class="categoriaBox">
                        {{arq.categoria}}
                    </div>
                </div>
            </div>
            <div class="descricao">
                <div class="linkbox" (click)="baixar(arq.link,arq.titulo,arq.tipo)">
                    {{arq.link}}
                </div>
                {{arq.novaDescricao}}
                <div *ngIf="edicao" style="text-align: right;">
                    <span >
                        <button pButton type="button" icon="pi pi-pencil" iconPos="left"  (click)="editarEquipamento(arq)" pTooltip="Editar"></button><span style="margin-left: 6px"></span>
                    </span> 
                    <span >
                        <button pButton type="button" icon="pi pi-trash" class="ui-button-danger" iconPos="left"  (click)="confirmarExclusao(arq)" pTooltip="Excluir"></button>
                    </span>
                </div>
            </div>
        </div>
        
    </div>
</div>


<p-toast position="center" key="myKey1" (onClose)="onReject()" [modal]="true"  life="60000" >
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <h2>Deletar Arquivo</h2>
            
            <!--message.detail.-->
            Tem certeza que deseja remover este Arquivo? <br>
            <b>( {{ message.detail.titulo}} )</b>
           <br> <br> <hr>
            <button pButton type="button"  class="ui-button-secondary" label="Cancelar" (click)="cancelar()" ></button> <span style="margin-left: 6px"></span>
            <button pButton type="button" icon="fa fa-times" class="ui-button-danger" iconPos="left" label="Remover" (click)="excluir(message.detail.id)"></button>
        </div>
        
    </ng-template>
</p-toast>
</div>

<div *ngIf="modo=='trofeu'">
    
    <div *ngFor="let it of arquivos">
        <div class="caixa noselect aparecer" (click)="baixar(it.link,it.titulo,it.tipo)">
              <div class="trofeu">
                🏆  
                <div class="posicao">
                    {{it.novaDescricao.substring(0,2)}}
                </div>
              </div>
              
                <div class="corpo" innerHTML="{{it.descricao}}">
                
                </div>
              
              <div style="text-align: right;">
                <div class="data">
                    {{it.dia | dataMomento}}
                </div>
              </div>
              
        </div>
    </div>
    
</div>
